<!-- #region contact  us -->
<section [ngClass]="lang" class="contacts-us text-white p-5">
  <div class="container">
    <div class="row">
      <div class="col-md-11 col-sm-12 m-auto wow fadeInRight">
        <h2 *ngIf="lang == 'en'" class="text-left">
          <i class="fas fa-address-book"></i>
          Contact us
        </h2>

        <h2 *ngIf="lang == 'ar'" class="text-left">
          <i class="fas fa-address-book"></i>
          إتصل بنا
        </h2>
      </div>
    </div>

    <div *ngIf="lang=='en'" class='alert alert-success row alert-dismissible' style="display: none;" role='alert'>
      <h4 class='alert-heading'>Message successfully sent!</h4>
      <button type='button' class='close' data-dismiss='alert' aria-label='Close'>
        <span aria-hidden='true'>&times;</span>
      </button>
    </div>

    <div *ngIf="lang=='ar'" class='alert alert-success row alert-dismissible' style="display: none;" role='alert'>
      <h4 class='alert-heading'>تم ارسال الرسالة بنجاح!</h4>
      <button type='button' class='close' data-dismiss='alert' aria-label='Close'>
        <span aria-hidden='true'>&times;</span>
      </button>
    </div>

    <div *ngIf="lang=='en'" class='alert alert-danger row alert-dismissible' style="display: none;" role='alert'>
      <h4 class='alert-heading'>Failed to send message
        Try again!</h4>
      <button type='button' class='close' data-dismiss='alert' aria-label='Close'>
        <span aria-hidden='true'>&times;</span>
      </button>
    </div>

    <div *ngIf="lang=='ar'" class='alert alert-danger row alert-dismissible' style="display: none;" role='alert'>
      <h4 class='alert-heading'>فشل ارسال الرسالة
        اعد محاولة مرة اخرى!</h4>
      <button type='button' class='close' data-dismiss='alert' aria-label='Close'>
        <span aria-hidden='true'>&times;</span>
      </button>
    </div>

    <form id="myForm" [ngClass]="lang" action="mail.php" method="post" class="form-area contact-form text-right">
      <div class="row">
        <div class="col-lg-6 form-group d-flex flex-column">

          <input *ngIf="lang == 'en'" name="name" placeholder="Enter your name" onfocus="this.placeholder = ''"
            onblur="this.placeholder='Enter your name'" class="common-input form-control wow fadeInUp"
            data-wow-delay="0.1s" required="" type="text" />
          <input *ngIf="lang == 'ar'" name="name" placeholder="الأسم" onfocus="this.placeholder = ''"
            onblur="this.placeholder='الأسم'" class="common-input form-control wow fadeInUp" data-wow-delay="0.1s"
            required="" type="text" />

          <input *ngIf="lang == 'en'" name="email" placeholder="Enter email address"
            pattern="[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{1,63}$" onfocus="this.placeholder = ''"
            onblur="this.placeholder='Enter email address'" class="common-input form-control wow fadeInUp"
            data-wow-delay="0.2s" required="" type="email" />
          <input *ngIf="lang == 'ar'" name="email" placeholder="البريد الإلكتروني"
            pattern="[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{1,63}$" onfocus="this.placeholder = ''"
            onblur="this.placeholder='البريد الإلكتروني'" class="common-input form-control wow fadeInUp"
            data-wow-delay="0.2s" required="" type="email" />

          <input *ngIf="lang == 'en'" name="phone" placeholder="Enter phone number" onfocus="this.placeholder = ''"
            onblur="this.placeholder='Enter phone number'" class="common-input form-control wow fadeInUp"
            data-wow-delay="0.3s" required="" type="phone" />
          <input *ngIf="lang == 'ar'" name="phone" placeholder="الرقم الهاتف" onfocus="this.placeholder = ''"
            onblur="this.placeholder='الرقم الهاتف'" class="common-input form-control wow fadeInUp"
            data-wow-delay="0.3s" required="" type="phone" />

          <input *ngIf="lang == 'en'" name="subject" placeholder="Enter your subject" onfocus="this.placeholder = ''"
            onblur="this.placeholder='Enter your subject'" class="common-input form-control wow fadeInUp"
            data-wow-delay="0.4s" required="" type="text" />
          <input *ngIf="lang == 'ar'" name="subject" placeholder="العنوان" onfocus="this.placeholder = ''"
            onblur="this.placeholder='العنوان'" class="common-input form-control wow fadeInUp" data-wow-delay="0.4s"
            required="" type="text" />
        </div>

        <div class="col-lg-6 form-group ">
          <textarea *ngIf="lang == 'en'" class="common-textarea form-control wow fadeInUp" data-wow-delay="0.5s"
            name="message" placeholder="Messege" onfocus="this.placeholder = ''" onblur="this.placeholder='Messege'"
            required=""></textarea>
          <textarea *ngIf="lang == 'ar'" class="common-textarea form-control wow fadeInUp" data-wow-delay="0.5s"
            name="message" placeholder="الرسالة" onfocus="this.placeholder = ''" onblur="this.placeholder='الرسالة'"
            required=""></textarea>
        </div>

        <button *ngIf="lang == 'en'" class="btn waves-effect mt-1 col-lg-3 col-sm-9 m-auto wow fadeInUp"
          data-wow-delay="0.6s">
          <div class="submit-btn">
            Send Message<i class="fas fa-magic ml-2"></i>
          </div>
          <div class="loading-btn">
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            <span class="p-1">Sending...</span>
          </div>
        </button>

        <button *ngIf="lang == 'ar'" class="btn waves-effect mt-1 col-lg-3 col-sm-9 m-auto wow fadeInUp"
          data-wow-delay="0.6s">
          <div class="submit-btn">
            ارسال الرسالة<i class="fas fa-magic ml-2"></i>
          </div>
          <div class="loading-btn">
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            <span class="p-1">جاري الإرسال...</span>
          </div>
        </button>

      </div>
    </form>

    <div class="row">
      <div class="col-md-6 col-sm-12 m-auto wow fadeInRight">

        <p *ngIf="lang == 'en'" class="text-justify">
          Al Jazar St. Al Riyadh area
          <br />
          Khartoum, SUDAN
        </p>

        <p *ngIf="lang == 'ar'" class="text-justify">
          شارع الجزار، حي الرياض
          <br />
          الخرطوم، السودان
        </p>

        <p class="text-justify">
          <a href="mailto:info@Company-sd.com">
            <i class="fa fa-at" aria-hidden="true"></i>
            <b *ngIf="lang == 'en'">E-mail:</b>
            <b *ngIf="lang == 'ar'">البريد الإلكتروني:</b>
            info@Company-sd.com
          </a>
        </p>

        <p class="text-justify">
          <a href="tel:+249183234900">
            <i class="fa fa-phone" aria-hidden="true"></i>
            <b *ngIf="lang == 'en'">Tel:</b>
            <b *ngIf="lang == 'ar'">هاتف الثابت:</b>
            <span dir="auto" class="p-1">+249183234900</span>
          </a>
        </p>

        <p class="text-justify">
          <a>
            <i class="fa fa-fax" aria-hidden="true"></i>
            <b *ngIf="lang == 'en'">Fax:</b>
            <b *ngIf="lang == 'ar'">فاكس:</b>
            <span dir="auto" class="p-1">+249183523401</span>
          </a>
        </p>

        <p class="text-justify">
          <i class="fa fa-box" aria-hidden="true"></i>
          <b *ngIf="lang == 'en'">P.O Box:</b>
          <b *ngIf="lang == 'ar'">صندوق البريد:</b>
          7091
          <b *ngIf="lang == 'en'">Postal Code:</b>
          <b *ngIf="lang == 'ar'">رقم الكود:</b>
          1123
        </p>
      </div>

      <img class="col-md-4 m-auto col-sm-12 wow fadeInLeft" src="../../../../assets/images/logo/logo_white.svg"
        alt="Logo" />
    </div>
  </div>
</section>
<!-- #endregion -->
